import { createFileRoute } from "@tanstack/react-router";

import { parseTemplatesSearch } from "../../../../areas/seller/more/templates/search";
import { TemplatesPage } from "../../../../areas/seller/more/templates/TemplatesPage";

/**
 * Template gallery (FE-09 FR-FE09-18…23) at the FE-01 §6.1 path; filters live in the URL
 * (`?category=&all=1`, FR-FE09-19).
 */
export const Route = createFileRoute("/app/_seller/more/gallery")({
  validateSearch: parseTemplatesSearch,
  component: TemplatesPage,
});
